import { render, staticRenderFns } from "./WarningIfProgramHasNoPeriod.vue?vue&type=template&id=4477d294&"
import script from "./WarningIfProgramHasNoPeriod.vue?vue&type=script&lang=js&"
export * from "./WarningIfProgramHasNoPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports